<app-alert></app-alert>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong id="pageTitle">MGT-1 Register of Members</strong>
    </span>
    <span style="float: right">
      <!-- <a routerLink="/mgt1/add"> -->
        <button (click)="addMGT1()" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
        [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}">
          <i class="fa fa-plus"></i>&nbsp;Add</button>
      <!-- </a> -->
    </span>
    <!-- <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
        <span>
          <i class="fa fa-save"></i>Generate Output </span>
      </button>
    </span> -->
  </div>
  <!-- Date Filter  -->
  <section class="card search-box">
    <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
          class="fa fa-filter" aria-hidden="true"></i></span> </div>
    <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-3">
              <label>Member Name
              </label>
              <div class="input-group">
                <input type="text" class="form-control" name="nameOfMember" [(ngModel)]="nameOfMember">
              </div>
              <br>
            </div>

            <div class="col-md-3">
              <!-- <label>Date of cessation of membership</label> -->
              <br>
              <div class="input-group" (click)="$event.stopPropagation()">
                From :&nbsp;
                <input id="doCessationOfMemebership" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="doCessationOfMemebership" ngbDatepicker
                  #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="doCessationOfMemebership">
                <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              
              </div>
            </div>


            <div class="col-md-3">
              
              <br>
              <div class="input-group" (click)="$event.stopPropagation()">
              
                 To :&nbsp;
                <input id="doBecomingMember" class="form-control" [minDate]="futureToDate"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="doBecomingMember" ngbDatepicker
                #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="doBecomingMember">
              <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
              </div>
            </div>





            <div class="col-lg-2 col-md-2 col-sm-2">
              <br>
              <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
              <div class="input-group">
                <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                  <i class="fa fa-search"></i>&nbsp;Search</button>
                &nbsp;&nbsp;&nbsp;
                <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                  (click)="clearAdvSearch()">
                  <i class="fa fa-refresh"></i>&nbsp;Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Date filter End -->
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive">
            <table datatable [dtOptions]="dtOptionsOfMasterDirector" [dtTrigger]="dtTriggerMasterDirector"
              class="table table-hover compact cell-border nowrap stripe" id="mgt1listTable" style="cursor: pointer;">
              <thead>
                <tr>

                  <th>Folio No./<br>Demat A/c No.</th>
                  <th>Member Name</th>
                  <th>Type of <br>Shareholder</th>
                  <th>Class of Share</th>
                  <th>No. of Shares</th>
                  <th style="width: 10px!important">Date of cessation <br>of membership</th>
                  <th style="display: none;">Date of cessation of membership</th>
                  <th style="width: 10px!important">Date of<br> becoming member</th>
                  <th style="display: none;">Date of becoming member</th>
                  <!-- <th>Status</th> -->
                  <th class="actionclass">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let director of registerMgt1List;">
                  <td>{{director.folioNoDematAcNo}}</td>
                  <td>{{director.personalDetails.nameOfMember}}</td>
                  <td>{{director.personalDetails.typesOfShareholders}}</td>
                  <td>{{director.selectTypes}}</td>
                  <td>{{director.totalNoOfSharesHeld}}</td>

                  <td style="width: 10px!important">
                    <span *ngIf="director.detailsOfMembers">
                    <span style="display: none">{{director.detailsOfMembers.doCessationOfMemebership | date : "yMMdd"}}</span>
                    {{director.detailsOfMembers.doCessationOfMemebership | date : "dd-MM-y"}}
                  </span>
                  </td>
                  <td style="display: none;">
                    <span *ngIf="director.detailsOfMembers">
                    {{director.detailsOfMembers.doCessationOfMemebership | date : "dd-MM-y"}}
                    </span>
                  </td>


          
                  <td style="width: 10px!important">
                    <span *ngIf="director.detailsOfMembers">
                    <span style="display: none">{{director.detailsOfMembers.doBecomingMember | date : "yMMdd"}}</span>
                    {{director.detailsOfMembers.doBecomingMember | date : "dd-MM-y"}}
                  </span>
                  </td>
                  <td style="display: none;">
                    <span *ngIf="director.detailsOfMembers">
                    {{director.detailsOfMembers.doBecomingMember | date : "dd-MM-y"}}
                    </span>
                  </td>




                  <td style='white-space: nowrap'>
                    <a>
                      <button type="button" (click)="editmgt1details(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}">
                        <span class="fa fa-pencil"></span>
                      </button>
                      <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}">
                          <span class="icmn-bin"></span>
                        </button>
                    </a>
                   
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
  style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="myModalLabelForDelete">
          <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            Are you sure you want to delete MGT-1 details?
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger" (click)="deletemgt1detail()">
          <i class="fa fa-check"></i>&nbsp;Yes
        </button>
        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
          <i class="fa fa-times"></i>&nbsp;No
        </button>
      </div>
    </div>
  </div>
</div>